import { useState } from 'react';
import { useQuery } from 'react-query';
import { getTechnicianTickets } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem, Ticket } from 'types';

export const useTechTickets = (status: '0' | '1' | null, techId?: string) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(5);

  const { data, isLoading: isTicketsLoading } = useQuery(
    [
      'get-tickets',
      {
        technicianId: techId,
        page: currentPage,
        per_page: recordsPerPage,
        status
      },
    ],
    getTechnicianTickets,
    {
      onError: (error: JsonDataItem) => {
        Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
      },
    },
  );

  const paginationMetadata = {
    current_page: data?.meta?.current_page || 1,
    total: data?.meta?.total || 0,
    pageSize: data?.meta?.per_page || 5,
    onChange: (page: number, pageSize: number) => {
      setCurrentPage(page);
      setRecordsPerPage(pageSize);
    },
  };

  const tickets = data?.data.map((ticket) => {
    return {
      ...ticket,
      // map some fields to match with the Ticket type
      type: ticket.type?.desc,
      task_links: {
        customer: {
          name: {
            full_name: ticket.customer?.full_name,
          },
        },
      },
    } as Ticket;
  });

  return {
    tickets,
    isTicketsLoading: isTicketsLoading,
    paginationMetadata,
  };
};
